import React from "react"
import classnames from "classnames"
import styles from "./Slideshow.less"
import { Image } from "AtomicContainers"
import { A, YoutubePlayer } from "AtomicComponents"

class Slideshow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: props.activeIndex || 0,
      xStart: 0,
      xEnd: 0
    }
  }

  componentDidMount() {
    const { activeIndex } = this.props
    if (this.slideshow){
      this.slideshow.addEventListener("mousedown", this._handleDown)
      this.slideshow.addEventListener("touchstart", this._handleDown)

      this.slideshow.addEventListener("mouseup", this._handleUp)
      this.slideshow.addEventListener("touchend", this._handleUp)
    }

    // we don't want to call the parent if slideshow is just updated
    // from outside
    this._handleClick(activeIndex || 0, false)
  }

  // ComponentWillRecieveProps is depricated!
  componentDidUpdate(prevProps) {
    const { activeIndex } = this.props
    if (activeIndex !== prevProps.activeIndex) {
      this.setState({
        activeIndex: activeIndex
      })
    }
  }

  _handleDown = e => {
    let screenX = 0
    if (e.screenX) screenX = e.screenX
    if (e.touches && e.touches[0] && e.touches[0].clientX)
      screenX = e.touches[0].clientX
    this.setState({
      xStart: screenX
    })
  }

  _handleUp = e => {
    let xEnd = 0
    if (e.screenX) xEnd = e.screenX
    if (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX)
      xEnd = e.changedTouches[0].clientX
    this.setState(
      {
        xEnd: xEnd
      },
      () => {
        const { xStart, xEnd, activeIndex } = this.state
        const { slides } = this.props
        if (xStart - xEnd > 30 && activeIndex < slides.length - 1) {
          this._handleClick(activeIndex + 1)
        } else if (xEnd - xStart > 30 && activeIndex > 0) {
          this._handleClick(activeIndex - 1)
        }
      }
    )
  }

  _handleClick = (activeIndex, callOnClickOfParent = true) => {
    const { onClick = () => {} } = this.props
    this.setState(
      {
        activeIndex: activeIndex
      },
      () => {
        if (callOnClickOfParent)
          onClick(activeIndex)
      }
    )
  }

  render() {
    const { slides, dotsEnabled = true, contain = false } = this.props
    const { activeIndex } = this.state
    return (
      <div
        className={classnames({
          [styles.Slideshow]: true,
          [styles.SlideshowContain]: contain
        })}>
        {slides && (
          <div ref={c => (this.slideshow = c)}>
            {
              slides[activeIndex].imageSrc &&
              !(slides[activeIndex].youtubeId || slides[activeIndex].youtubeLink) &&
              <Image
                contain={contain}
                src={slides[activeIndex].imageSrc}
                height={300}
              />
            }
            {
              (slides[activeIndex].youtubeId || slides[activeIndex].youtubeLink) &&
              <YoutubePlayer
                youtubeId={slides[activeIndex].youtubeId}
                youtubeLink={!slides[activeIndex].youtubeId && slides[activeIndex].youtubeLink}
              />
            }
          </div>
        )}
        {dotsEnabled && (
          <ul
            className={classnames({
              [styles.dots]: true
            })}>
            {slides.map((item, index) => (
              <li key={`Slides-${index}`}>
                <A
                  withoutStyle
                  onClick={() => this._handleClick(index)}
                  className={classnames({
                    [styles.dotSingle]: true,
                    [styles.dotSingleActive]: activeIndex === index
                  })}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }
}

export default Slideshow



// WEBPACK FOOTER //
// ./src/AtomicContainers/Slideshow/Slideshow.jsx